// @ts-ignore
import AmpersandEvents from 'ampersand-events';
import {EntityType} from "../const/item";

// const debugMonitor = 'ModelBus'; // set to false to disable but dont remove name !
const debugMonitor = false;

export default class ModelBus {

    private emmiter     : any
    private debouncedEvents     : any

    // when we start working with TASKS - thinkg about special methods for tasks (!)
    // i.e. for specific project ... or root project or something like that

    constructor() {
        this.emmiter = AmpersandEvents.createEmitter();
        this.debouncedEvents = {};
    }

    newUpdate(modelName:string|EntityType, method:string, recordId:ID, data:any, header:any) {

        // trigger for all records
        debugMonitor && console.log(debugMonitor, 'triggerUpdate whole model', modelName)
        this.emmiter.trigger(modelName, method, data, header);

        // now trigger for specific record
        debugMonitor && console.log(debugMonitor, 'triggerUpdate record ', modelName+"."+recordId)
        this.emmiter.trigger(modelName+"."+recordId, method, data, header);
    }

    // Yes from now - let us use EntityType where we can... I think it makes sense
    subscribe(modelIdentificator:string|EntityType, context:any , callback:any) {
        debugMonitor && console.log(debugMonitor, 'subscribe to ', modelIdentificator)

        // modeIdentificator can be just model name i.e.: crm-contact
        // or specific id i.e.: crm-contact.ABCDEFG
        // use model-name.MODEL-ID when we really care about specific i.e. when we open contact for view
        // user mode-name when we want to care about ALL items changes and process them nanually


        if (modelIdentificator===EntityType.MEETING) modelIdentificator = 'meeting'


        this.emmiter.on(modelIdentificator, callback, context);
    }

    unsubscribeEvent(modelIdentificator:EntityType, context:any) {
        debugMonitor && console.log(debugMonitor," unsubscribe", modelIdentificator, context);

        if (!context) console.warn("ModelBus: unsubscribe without context will unsubscribe All modelIdentificator events!");
        this.emmiter.off(modelIdentificator,null,context);
    }

    unsubscribe(context:any) {
        debugMonitor && console.log(debugMonitor," unsubscribe", context);

        if (!context) console.warn("ModelBus: unsubscribe without context will unsubscribe All events!");
        this.emmiter.off(null,null,context);
    }

    debug() {
        console.log("ModelBus:")
        console.log("Emiters total=",_.size(this.emmiter._events))
        console.log("Emiters", this.emmiter._events);

    }
};
